<template>
  <div class="shopping-cart-page">
    <h2>カートの中身</h2>
    <ul>
      <li v-for="item in cartItems" :key="item.product_id" class="cart-item">
        <img :src="getImageUrl(item.image_url)" alt="商品画像" class="item-image" />
        <div class="item-details">
          <span>{{ item.name }}</span> - ¥{{ item.price }} x {{ item.quantity }}
          <div class="stock-info">残り在庫: {{ item.stock_quantity }}個</div> <!-- 在庫状況を表示 -->
          <div class="quantity-controls">
            <button @click="increaseQuantity(item.product_id)">+</button>
            <span>{{ item.quantity }}</span>
            <button @click="decreaseQuantity(item.product_id)" :disabled="item.quantity <= 1">-</button>
            <button @click="removeFromCart(item.product_id)">削除</button>
          </div>
        </div>
      </li>
    </ul>
    <p v-if="cartTotal > 0">合計: ¥{{ cartTotal }}</p>
    <p v-else>カートは空です。</p>

    <button @click="purchaseItems" class="purchase-button">商品を購入</button>
    <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
  </div>
</template>

<script>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'ShoppingCartPage',
  setup() {
    const store = useStore();
    const errorMessage = ref('');

    const cartItems = computed(() => {
      const items = store.getters.cartItems;
      console.log('Cart items:', items); // デバッグ用
      return items;
    });
    const cartTotal = computed(() => store.getters.cartTotal);

    const removeFromCart = (productId) => {
      store.commit('removeFromCart', productId);
    };

    const increaseQuantity = (productId) => {
      store.commit('increaseQuantity', productId);
    };

    const decreaseQuantity = (productId) => {
      store.commit('decreaseQuantity', productId);
    };

    const getImageUrl = (imagePath) => {
      return imagePath
        ? require(`@/assets/images/${imagePath}`)
        : require('@/assets/images/default.png');
    };

    const purchaseItems = async () => {
      errorMessage.value = ''; // エラーメッセージを初期化
      for (const item of cartItems.value) {
        console.log(`Item: ${item.name}, Stock: ${item.stock_quantity}, Quantity: ${item.quantity}`); // デバッグ用
        if (item.stock_quantity < item.quantity) {
          errorMessage.value = `${item.name}の在庫が不足しています。`;
          return;
        }
      }

      try {
        const updatePromises = cartItems.value.map(async (item) => {
          const newStockQuantity = item.stock_quantity - item.quantity; // 新しい在庫数量を計算
          console.log(`Updating product_id: ${item.product_id}, new_stock_quantity: ${newStockQuantity}`); // デバッグ用

          // 在庫数量が正しい値であるか確認
          if (newStockQuantity < 0) {
            throw new Error(`${item.name}の在庫がマイナスになっています。`);
          }

          const response = await fetch(`http://172.16.80.71:5000/api/products/${item.product_id}`, {
            method: 'PATCH',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ stock_quantity: newStockQuantity }), // 在庫を減少させる
          });

          if (!response.ok) {
            throw new Error(`${item.name}の購入処理に失敗しました。`);
          }
        });

        await Promise.all(updatePromises);
        alert('購入が完了しました！');
        store.commit('clearCart');
      } catch (error) {
        console.error('購入中にエラーが発生しました:', error);
        errorMessage.value = error.message || '購入中にエラーが発生しました。';
      }
    };

    return {
      cartItems,
      cartTotal,
      removeFromCart,
      increaseQuantity,
      decreaseQuantity,
      getImageUrl,
      purchaseItems,
      errorMessage,
    };
  },
};
</script>

<style>
.shopping-cart-page {
  padding: 20px;
}

.shopping-cart-page ul {
  list-style-type: none;
  padding: 0;
}

.cart-item {
  display: flex;
  align-items: center;
  margin: 10px 0;
}

.item-image {
  width: 50px;
  height: 50px;
  margin-right: 10px;
}

.item-details {
  flex-grow: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.stock-info {
  color: #666; /* 在庫表示の色をグレーに */
  font-size: 0.9em; /* フォントサイズを少し小さく */
}

.quantity-controls {
  display: flex;
  align-items: center;
}

.quantity-controls button {
  margin: 0 5px;
}

.purchase-button {
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #4CAF50;
  color: white;
  border: none;
  cursor: pointer;
}

.error-message {
  color: red;
  margin-top: 10px;
}
</style>